import { MAX_NUM_COLUMNS } from '../../tokens/appconfig';

export function fillToNumColumns<T>(arr: T[][]): T[][] {
  return [...arr, ...Array(MAX_NUM_COLUMNS - arr.length).fill([])];
}
